import React from 'react';

const H2: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <h2 style={{ fontSize: 20, margin: '28px 0 10px' }}>{children}</h2>
);

const P: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p style={{ lineHeight: 1.7, marginBottom: 12 }}>{children}</p>
);

const LI: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <li style={{ lineHeight: 1.7, marginBottom: 6 }}>{children}</li>
);

const PrivacyPolicy: React.FC = () => (
  <div className="section">
    <div className="wrap">
      <div className="measure" style={{ margin: '0 auto' }}>
        <span className="eyebrow" style={{ display: 'block', marginBottom: 10 }}>
          Trust
        </span>
        <h1 style={{ fontSize: 32, marginBottom: 8 }}>Privacy Policy</h1>
        <p className="meta" style={{ marginBottom: 24 }}>Effective date: August 2025</p>

        <H2>1. Information we collect</H2>
        <P>Common Room collects information to provide and improve our services:</P>
        <ul style={{ paddingLeft: 20, marginBottom: 12 }}>
          <LI>Account information (name, email, school, grade level)</LI>
          <LI>Academic data (grades, test scores, activities, achievements)</LI>
          <LI>Session bookings, messages, and materials you share with mentors</LI>
          <LI>Google account data used for sign-in (with your permission)</LI>
          <LI>Usage data to improve our services</LI>
        </ul>

        <H2>2. How we use your information</H2>
        <P>We use your information to:</P>
        <ul style={{ paddingLeft: 20, marginBottom: 12 }}>
          <LI>Match families with mentors and run booked sessions</LI>
          <LI>Verify mentor credentials against official sources</LI>
          <LI>Deliver session recordings, notes, and summaries</LI>
          <LI>Send notifications and reminders</LI>
          <LI>Communicate important updates about our service</LI>
        </ul>

        <H2>3. Google sign-in</H2>
        <P>
          When you sign in with Google, we access basic profile information (name, email,
          profile photo). We only access this data when you explicitly authorize it and use it
          solely to operate your account.
        </P>

        <H2>4. Data security</H2>
        <P>We implement industry-standard security measures to protect your data:</P>
        <ul style={{ paddingLeft: 20, marginBottom: 12 }}>
          <LI>Encrypted data transmission (HTTPS)</LI>
          <LI>Secure database storage</LI>
          <LI>Regular security audits</LI>
          <LI>Limited access to personal information</LI>
        </ul>

        <H2>5. Data sharing</H2>
        <P>We do not sell, trade, or rent your personal information. We may share data only:</P>
        <ul style={{ paddingLeft: 20, marginBottom: 12 }}>
          <LI>With your explicit consent</LI>
          <LI>To comply with legal obligations</LI>
          <LI>
            With service providers who help us operate our platform (under strict
            confidentiality agreements)
          </LI>
        </ul>

        <H2>6. Your rights</H2>
        <P>You have the right to:</P>
        <ul style={{ paddingLeft: 20, marginBottom: 12 }}>
          <LI>Access your personal data</LI>
          <LI>Correct inaccurate information</LI>
          <LI>Delete your account and associated data</LI>
          <LI>Opt out of promotional communications</LI>
        </ul>

        <H2>7. Children's privacy</H2>
        <P>
          Our service is designed for families with high-school students (typically ages 14–18).
          We require parental consent for users under 16 in accordance with applicable laws.
        </P>

        <H2>8. Changes to this policy</H2>
        <P>
          We may update this privacy policy from time to time. We will notify you of any
          material changes via email or through the app.
        </P>

        <H2>9. Contact us</H2>
        <P>
          If you have questions about this privacy policy or our data practices, please contact
          us at privacy@commonroom.example.
        </P>
      </div>
    </div>
  </div>
);

export default PrivacyPolicy;
